import { render, staticRenderFns } from "./lcmb.vue?vue&type=template&id=33965b32&scoped=true&"
import script from "./lcmb.vue?vue&type=script&lang=js&"
export * from "./lcmb.vue?vue&type=script&lang=js&"
import style0 from "./lcmb.vue?vue&type=style&index=0&id=33965b32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33965b32",
  null
  
)

export default component.exports